<div class="flex-direction-column padding-5px width-97">
  <div>
    <div class="flex-direction-row justify-between align-center" style="margin-bottom: 1.2vh">
      <div class="flex-direction-row align-center gap-10" [formGroup]="formSessao">
        <div>
          <app-button-padrao
            iconSrc="icones/filtros"
            iconSrcExtensao=".svg"
            width="30px"
            height="30px"
            backgroundColor="transparent"
            widthIcon="22px"
            heightIcon="22px"
            matTooltip="Filtrar"
            (buttonClick)="abrirModalFiltro()">
          </app-button-padrao>
        </div>
        <div>
          <app-button-padrao
            iconSrc="icones/limpar"
            iconSrcExtensao=".svg"
            width="30px"
            height="30px"
            backgroundColor="transparent"
            widthIcon="22px"
            heightIcon="22px"
            matTooltip="Limpar filtros"
            (buttonClick)="iniciarFiltros()"
          >
          </app-button-padrao>
        </div>

        <div>
          @if (!btnBuscaAcionado) {
            <div class="btn-busca" role="button" tabindex="0" (click)="btnBuscaAcionado = true;" (keydown.enter)="btnBuscaAcionado = true;">
              <mat-icon>search</mat-icon>
            </div>
          }
          @else {
              <app-form-field
                style="margin-top: 20px"
                placeholder="Pesquisar"
                iconPrefix="search"
                iconColor="var(--primary)"
                backgroundColor="transparent"
                classe="pesquisar"
                widthFormField="161px"
                heightFormField="35px"
                borderColor="var(--primary)"
                formControlName="numNome"
              ></app-form-field>
          }
        </div>
      </div>
    </div>
  </div>
  @if (carregando) {
    <app-card-mobile-skeleton [qntdLinhas]="5"></app-card-mobile-skeleton>
  }
  @else if (sessoes && sessoes.length > 0) {
    <div class="flex-direction-column gap-1rem width-100 center-center border-box">
      @for (sessao of sessoes; track sessao.id) {
        @if (larguraTela && larguraTela >= 700) {
          <app-card-sessao-tablet
            [sessao]="sessao"
            (exibirDetalhes)="exibirDetalhes.emit(sessao)"
            (modalChat)="modalChat.emit(sessao)"
            (exibirEdicaoDetalhes)="edicaoDetalhes.emit(sessao)"
            (reiniciarSessao)="reiniciarSessao.emit(sessao)"
          >
          </app-card-sessao-tablet>
        }
        @else {
          <app-card-sessao-mobile
            [sessao]="sessao"
            (exibirDetalhes)="exibirDetalhes.emit(sessao)"
            (modalChat)="modalChat.emit(sessao)"
            (exibirEdicaoDetalhes)="edicaoDetalhes.emit(sessao)"
            (reiniciarSessao)="reiniciarSessao.emit(sessao)"
          >
          </app-card-sessao-mobile>
        }
      }
    </div>
  }
  @else {
    <div class="flex center-center width-100" style="margin-top: 2rem;">
      <img style="max-width: 90%; height: auto;" src="./assets/imagem-mulher-nao-eh-bug.png" alt="">
    </div>
  }

</div>
